import React, {Fragment, useEffect, useState} from 'react';
import {Button, MenuItem, Icon, Tag, Tooltip} from '@blueprintjs/core';
import {Suggest, Select} from '@blueprintjs/select';

import {Row, Cell} from '/src/components/tables/table'


const EditingItemForm = (
    {
        item: initialItem,
        taxonomiesInUse: initialTaxonomiesInUse,
        elems,
        cancelEditing,
        editItem,
        saveItem,
        setShapeHighlight,
        loadingTaxonomies,
    }) => {
    const [taxonomiesInUse, setTaxonomiesInUse] = useState(initialTaxonomiesInUse);
    const [item, setItem] = useState(initialItem);

    useEffect(() => {
        setTaxonomiesInUse(initialTaxonomiesInUse);
    }, [initialTaxonomiesInUse]);

    useEffect(() => {
        editItem(item);
    }, [item])

    return <Row>
        <Cell span={2} halign="center" valign="center">
            <Select
                popoverProps={{minimal: true}}
                items={["taxonomy", "location-entry", "location-dwell"]}
                filterable={false}
                itemRenderer={(tType, {handleClick}) => (
                    <MenuItem
                        key={tType}
                        text={<Tag minimal>{`${tType}`}</Tag>}
                        onClick={handleClick}
                    />
                )}
                noResults={<MenuItem disabled={true} text="No results."/>}
                onItemSelect={(tType) => setItem({...item, type: tType})}
            >
                <Tag minimal rightIcon="caret-down">{item.type || "Context Type"}</Tag>
            </Select>
        </Cell>
        <Cell span={2} halign="center" valign="center">
            <Select
                popoverProps={{minimal: true}}
                items={elems.areas}
                filterable={false}
                itemRenderer={(elem, {handleClick}) => (
                    <MenuItem
                        key={elem.name}
                        text={<Tag minimal intent="primary">{elem.name}</Tag>}
                        onMouseEnter={() => setShapeHighlight(elem, true)}
                        onMouseLeave={() => setShapeHighlight(elem, false)}
                        onClick={handleClick}
                    />
                )}
                noResults={<MenuItem disabled={true} text="No results."/>}
                onItemSelect={(elem) => setItem({...item, areaId: elem.name})}
            >
                <Tag
                    minimal rightIcon="caret-down"
                    intent={item.areaId? "primary" : "none"}
                >
                    {item.areaId || "Select Area"}
                </Tag>
            </Select>
        </Cell>
        <Cell span={3} halign="center" valign="center">
            {item.type === 'taxonomy' && (
                <Fragment>
                    <Suggest
                        popoverProps={{minimal: true}}
                        inputProps={{small: true, fill: false}}
                        query={item.taxonomy? `${item.taxonomy}` : undefined}
                        items={!loadingTaxonomies && taxonomiesInUse ? taxonomiesInUse.sort((a, z) => a - z) : []}
                        itemPredicate={(query, item) => !!item && item.toLowerCase().indexOf(query.toLowerCase()) >= 0}
                        inputValueRenderer={() => null}
                        itemRenderer={(taxonomy, {handleClick}) => (
                            <MenuItem
                                key={taxonomy}
                                text={`${taxonomy}`}
                                onClick={handleClick}
                            />
                        )}
                        noResults={<MenuItem disabled={true} text="No results."/>}
                        onItemSelect={(taxonomy) => setItem({...item, taxonomy: taxonomy})}
                        onQueryChange={(taxonomy) => setItem({...item, taxonomy: taxonomy})}
                    />
                    <Tooltip
                        content={
                            <div>
                                <p>Taxonomies are colon (:) separated to denote A hierarchy,</p>
                                <p>so enter a taxonomy in the format{' '}</p>
                                <p><em>Category:Subcategory:Sub-sub-category</em>.</p>
                                <p>A real world example might be <em>Products:iPhones</em></p>
                            </div>
                        }
                    >
                        <Icon icon="help"/>
                    </Tooltip>
                </Fragment>
            )}
        </Cell>
        <Cell span={1} halign="center" valign="center" gap="10px">
            <Fragment>
                <Icon
                    icon="floppy-disk"
                    htmlTitle="Save"
                    intent="success"
                    onClick={() => saveItem(item)}
                />
                <Icon
                    icon="delete"
                    htmlTitle="Cancel"
                    intent="danger"
                    onClick={cancelEditing}
                />
            </Fragment>
        </Cell>
    </Row>
}

export default EditingItemForm;
